document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('cart-drawer');
  const openBtn = document.getElementById('open-cart-drawer');
  const openBtnMob = document.getElementById('open-cart-drawer-mob');
  const closeBtn = document.getElementById('close-cart-drawer');
  const cartItemsContainer = document.getElementById('cart-items');
  const shippingProgress = document.getElementById('shipping-progress');
  const shippingMessage = document.getElementById('shipping-message');
  const upsellSection = document.getElementById('upsells');
  const cartSubtotal = document.getElementById('cart-subtotal');

  const FREE_SHIPPING_THRESHOLD = 3000;
  const UPSELL_COLLECTION_HANDLE = 'shop';

  function openCartDrawer() {
    cartDrawer.classList.remove('hidden');
  }

  function closeCartDrawer() {
    cartDrawer.classList.add('hidden');
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        renderCartItems(cart.items);
        updateShippingProgress(cart.total_price / 100);
        updateSubtotal(cart.total_price / 100);
        fetchUpsells(cart.items);
      })
      .catch(err => console.error('Error fetching cart:', err));
  }

  function renderCartItems(items) {
    cartItemsContainer.innerHTML = '';

    if (items.length === 0) {
      cartItemsContainer.innerHTML = '<p>Your cart is empty.</p>';
      return;
    }

    const totalItems = items.reduce((sum, item) => sum + item.quantity, 0);

  // Add the heading
  const heading = document.createElement('h2');
  heading.className = 'items_count';
  heading.textContent = `Your Cart (${totalItems})`;
  cartItemsContainer.appendChild(heading);

    items.forEach(item => {
      const div = document.createElement('div');
      div.className = 'cart_item';
      div.innerHTML = `
      <div class="cart_inner">
        <div class="item_image">
          <img src="${item.image}" alt="${item.title}" width="80"/>
        </div>
        <div class="left_part">
          <p class="item_title">${item.product_title}</p>
          ${item.variant_title ? `<p class="item_variant">${item.variant_title}</p>` : ''}
         ${item.selling_plan_allocation?.selling_plan?.name ? `
  <div class="item_subscription">
    ${item.selling_plan_allocation.selling_plan.name}
  </div>
` : ''}
          <div class="qty-btns">
            <button data-line="${item.key}" class="qty-minus">−</button>
            <span>${item.quantity}</span>
            <button data-line="${item.key}" class="qty-plus">+</button>
          </div>
        </div>
        <div class="right_part">
                  <span>Rs. ${(item.line_price / 100).toFixed(2)}</span>
                  <button data-line="${item.key}" class="item-remove">X</button>
          </div>
          </div>
          ${!item.selling_plan_allocation ? `
  <div class="switch_btn mt-1">
    <a href="${item.url}" class="text-sm text-blue-600 underline">
      Switch to Subscribe and Save 25%
    </a>
  </div>
` : ''}
      `;
      cartItemsContainer.appendChild(div);
          console.log(item);
    });
    cartItemsContainer.querySelectorAll('.qty-minus').forEach(btn => {
      btn.addEventListener('click', () => updateItemQuantity(btn.dataset.line, -1));
    });

    cartItemsContainer.querySelectorAll('.qty-plus').forEach(btn => {
      btn.addEventListener('click', () => updateItemQuantity(btn.dataset.line, 1));
    });

    cartItemsContainer.querySelectorAll('.item-remove').forEach(btn => {
      btn.addEventListener('click', () => updateItemQuantity(btn.dataset.line, 0, true));
    });
  }

  function updateItemQuantity(lineItemKey, change, isDelete = false) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const item = cart.items.find(i => i.key === lineItemKey);
        if (!item) return;

        const newQty = isDelete ? 0 : item.quantity + change;
        if (newQty < 0) return;

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: lineItemKey,
            quantity: newQty
          })
        });
      })
      .then(() => fetchCart())
      .catch(err => console.error('Error updating quantity:', err));
  }

  function updateShippingProgress(total) {
    const percentage = Math.min(100, (total / FREE_SHIPPING_THRESHOLD) * 100);
    shippingProgress.style.width = `${percentage}%`;

    if (total >= FREE_SHIPPING_THRESHOLD) {
      shippingMessage.textContent = "🎉 You’ve unlocked a free tin!";
    } else {
      const remaining = FREE_SHIPPING_THRESHOLD - total;
      shippingMessage.textContent = `You're ₹${remaining.toFixed(2)} away from a free tin.`;
    }
  }

  function updateSubtotal(total) {
    cartSubtotal.textContent = `Rs.${total.toFixed(2)}`;
  }

function fetchUpsells(cartItems) {
  upsellSection.innerHTML = '';

  const cartProductIds = cartItems.map(i => i.product_id);

  fetch(`/collections/${UPSELL_COLLECTION_HANDLE}/products.json?limit=6`)
    .then(res => res.json())
    .then(data => {
      const upsellProducts = data.products.filter(p => !cartProductIds.includes(p.id));

      upsellProducts.forEach(p => {
        const variant = p.variants[0];
        const upsell = document.createElement('div');
        upsell.className = 'upsell_item';
        upsell.innerHTML = `
          <div class="border p-2 rounded mb-2">
            <img src="${p.images[0]?.src || ''}" alt="${p.title}" width="100" height="100" class="mb-1" />
            <p class="text-sm font-medium">${p.title}</p>
            <button 
              class="bg-black text-white text-xs px-2 py-1 rounded add-upsell-btn"
              data-variant-id="${variant.id}"
            >
              Add+
            </button>
          </div>
        `;

        upsellSection.appendChild(upsell);
      });

      // Attach event listeners to each "Add" button
      document.querySelectorAll('.add-upsell-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const variantId = btn.dataset.variantId;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ quantity: 1, id: variantId })
          })
            .then(() => fetchCart())
            .catch(err => {
              console.error('Error adding upsell product:', err);
              alert('Could not add upsell product.');
            });
        });
      });
    })
    .catch(err => {
      console.error('Error fetching upsells:', err);
      upsellSection.innerHTML = '<p>Could not load upsells.</p>';
    });
}
  openBtn?.addEventListener('click', () => {
    openCartDrawer();
    fetchCart();
  });
    openBtnMob?.addEventListener('click', () => {
    openCartDrawer();
    fetchCart();
  });

  closeBtn?.addEventListener('click', closeCartDrawer);

  document.querySelectorAll('form.product-form').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
      .then(res => {
        if (!res.ok) throw new Error('Failed to add to cart');
        return res.json();
      })
      .then(() => {
        fetchCart();
        openCartDrawer();
      })
      .catch(err => {
        console.error(err);
        alert('Could not add to cart.');
      });
    });
  });
});

document.querySelector('#newsletter-form input[name="newsletter_opt_in"]')?.addEventListener('change', function () {
  const data = {
    note_attributes: {
      newsletter_opt_in: this.checked ? 'yes' : ''
    }
  };

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  })
  .then(res => res.json())
  .then(cart => {
    console.log('Newsletter preference saved:', cart.note_attributes);
  })
  .catch(err => console.error('Error saving newsletter opt-in:', err));
});
